import React, { useState, useEffect } from 'react';
import authentication from '../../B2CAuth';
import logComponent from '../../common/logComponent';

export default function AuthenticatedTemplate({  children }) {
  const [signedIn, setSignedIn] = useState(null);
  useEffect(() => {
    if (logComponent('AuthenticatedTemplate')) { console.debug('AuthenticatedTemplate onMount'); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const interval = setInterval(() => {
      setSignedIn(authentication.signedIn());
    }, 1000);
    return () => clearInterval(interval);
  }, []);


  if (signedIn) {
    return (
      <div>
        {children}
      </div>
    );
  }
  return (null);
}
